import { render, staticRenderFns } from "./EnacProcedureAtpDafEditCompetencies.vue?vue&type=template&id=76e5210c"
import script from "./EnacProcedureAtpDafEditCompetencies.vue?vue&type=script&lang=js"
export * from "./EnacProcedureAtpDafEditCompetencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports